import LegacyUnitSnippet from 'scripts/defa/legacy/view-legacy-unit-snippet';

/**
 * defa.views.LegacyUnitCollectionView
 * A wrapper for your legacy units
 * @version 1.2.0
 */
import CollectionView    from 'scripts/poppet/collection-view';

const LegacyUnitCollectionView = CollectionView.extend( {
	
	// ------------------------------------------------
	// Setup
	// ------------------------------------------------
	
	childView: LegacyUnitSnippet,
	
	
	// ------------------------------------------------
	// Event Handlers
	// ------------------------------------------------
	
	// ------------------------------------------------
	// Other functions
	// ------------------------------------------------
	
} );

export default LegacyUnitCollectionView;